import { LeftArrow, RightArrow } from 'lib/styles/icons';
import palette from 'lib/styles/palette';
import { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import arrowHandler from 'utils/arrowHandler';
import getEmptyArray from 'utils/getEmptyArray';

const PageNumber = ({ page, setCurrentPage, isactive }) => {
  const onClick = () => {
    setCurrentPage(page);
  };

  return (
    <PageNumberBlock onClick={onClick} isactive={isactive}>
      <div>{page}</div>
    </PageNumberBlock>
  );
};

const PageNumberBlock = styled.div`
  cursor: pointer;
  &:hover {
    color: ${palette.theme[3]};
  }

  ${props =>
    props.isactive === 'true' &&
    css`
      color: ${palette.theme[3]};
    `}
`;

const Pagination = ({
  totalPage = 1,
  pagesPerList = 10,
  currentPage,
  setCurrentPage,
}) => {
  const [showingNum, setShowingNum] = useState({
    start: 1,
    end: pagesPerList,
  });

  const isFirstPage = showingNum.start === 1;
  const isLastPage = showingNum.end === totalPage;
  const pages = getEmptyArray(showingNum.start, showingNum.end);

  useEffect(() => {
    const lessThanPagesPerList = totalPage <= pagesPerList;
    lessThanPagesPerList
      ? setShowingNum(prev => ({ ...prev, start: 1, end: totalPage }))
      : setShowingNum(prev => ({ ...prev, start: 1, end: pagesPerList }));
  }, [totalPage, pagesPerList]);

  useEffect(() => {
    setCurrentPage(showingNum.start);
  }, [setCurrentPage, showingNum]);

  const changePageNumbersBackward = () => {
    if (currentPage > pagesPerList) {
      setShowingNum(prev =>
        arrowHandler({ ...prev }, -1, totalPage, pagesPerList),
      );
    }
  };

  const changePageNumbersForward = () => {
    if (showingNum.end < totalPage) {
      setShowingNum(prev =>
        arrowHandler({ ...prev }, 1, totalPage, pagesPerList),
      );
    }
  };

  return (
    <PaginationBlock>
      <StyledIcon
        isend={String(isFirstPage)}
        onClick={changePageNumbersBackward}
      >
        <LeftArrow />
      </StyledIcon>
      {pages.map((page, i) => {
        return (
          <PageNumber
            key={`pageNumber-${i + 1}`}
            page={page}
            setCurrentPage={setCurrentPage}
            isactive={String(page === currentPage)}
          />
        );
      })}
      <StyledIcon isend={String(isLastPage)} onClick={changePageNumbersForward}>
        <RightArrow />
      </StyledIcon>
    </PaginationBlock>
  );
};

export default Pagination;

const PaginationBlock = styled.div`
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  user-select: none;
  div + div {
    margin-left: 15px;
  }
`;

const StyledIcon = styled.div`
  &:hover {
    color: ${palette.theme[3]};
  }
  ${props =>
    props.isend === 'true' &&
    css`
      color: ${palette.gray[3]};
    `}
`;
